import { excelParadasState, excelParadasMutations, excelParadasActions } from "./paradaExcel";
import { enviosParadaState, enviosParadaMutations, enviosParadaActions } from "./paradaEnvios";
import { paradaService } from "@/_services";

export const parada = {
  namespaced: true,
  state: {
    ...excelParadasState(),
    eventosDisponibles: {
      requestId: 0,
      tipo: null,
      data: [],
      status: {},
    },
    newEventoParada: {
      requestId: 0,
      paradaId: null,
      data: null,
      status: {},
    },
    ...enviosParadaState(),
    list: {
      requestId: 0,
      data: [],
      status: {},
    },
    etiqueta: {
      data: null,
      status: {},
    },
    email: {
      data: {},
      status: {},
    },
    anular: {
      requestId: 0,
      paradaId: null,
      data: {},
      status: {},
    },
    estados: {
      data: [],
      status: {},
    },
    images: {
      data: [],
      status: {},
    },
    justificante: {
      data: null,
      status: {},
    },
    paradaId: {
      requestId: 0,
      data: null,
      status: {},
    },
    entityRecogida: {
      requestId: 0,
      data: {},
      status: {},
    },
  },
  mutations: {
    ...excelParadasMutations,
    resetEventoParada(state) {
      state.anular.requestId += 1;
      state.anular.paradaId = null;
      state.anular.data = null;
      state.anular.status = {};
      state.newEventoParada.requestId += 1;
      state.newEventoParada.paradaId = null;
      state.newEventoParada.data = null;
      state.newEventoParada.status = {};
      state.eventosDisponibles.requestId += 1;
      state.eventosDisponibles.tipo = null;
      state.eventosDisponibles.data = [];
      state.eventosDisponibles.status = {};
    },
    getEventosDisponiblesRequest(state, tipo) {
      state.eventosDisponibles.requestId += 1;
      state.eventosDisponibles.tipo = tipo;
      state.eventosDisponibles.data = [];
      state.eventosDisponibles.status = { loading: true };
    },
    getEventosDisponiblesSuccess(state, response) {
      state.eventosDisponibles.data = response.items || [];
      state.eventosDisponibles.status = { loaded: true };
    },
    getEventosDisponiblesError(state, error) {
      state.eventosDisponibles.data = [];
      state.eventosDisponibles.status = { error };
    },
    newEventoParadaRequest(state, paradaId) {
      state.newEventoParada.requestId += 1;
      state.newEventoParada.paradaId = paradaId;
      state.newEventoParada.data = null;
      state.newEventoParada.status = { creating: true };
    },
    newEventoParadaSuccess(state, response) {
      state.newEventoParada.data = response;
      state.newEventoParada.status = { created: true };
    },
    newEventoParadaError(state, error) {
      state.newEventoParada.data = null;
      state.newEventoParada.status = { error };
    },
    ...enviosParadaMutations,
    getParadaInfoRequest(state) {
      state.paradaId.requestId += 1;
      state.paradaId.data = null;
      state.paradaId.status = {
        loading: true,
      };
    },
    getParadaInfoError(state, error) {
      state.paradaId.data = [];
      state.paradaId.status = {
        error,
      };
    },
    getParadaInfoSuccess(state, response) {
      state.paradaId.data = response;
      state.paradaId.status = {
        loaded: true,
      };
    },
    resetParadaInfo(state) {
      state.paradaId.requestId += 1;
      state.paradaId.data = null;
      state.paradaId.status = {};
    },

    getParadasRequest(state) {
      state.list.requestId += 1;
      state.list.status = {
        loading: true,
      };
    },
    getParadasError(state, error) {
      state.list.data = [];
      state.list.status = {
        error,
      };
    },
    getParadasSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getEtiquetaPDFByParadaRequest(state) {
      state.etiqueta.status = {
        loading: true,
      };
    },
    getEtiquetaPDFByParadaError(state, error) {
      state.etiqueta.data = [];
      state.etiqueta.status = {
        error,
      };
    },
    getEtiquetaPDFByParadaSuccess(state, response) {
      state.etiqueta.data = response;
      state.etiqueta.status = {
        loaded: true,
      };
    },
    sendEmailEtiquetasByParadaRequest(state) {
      state.email.status = {
        sending: true,
      };
    },
    sendEmailEtiquetasByParadaError(state, error) {
      state.email.data = [];
      state.email.status = {
        error,
      };
    },
    sendEmailEtiquetasByParadaSuccess(state, response) {
      state.email.data = response;
      state.email.status = {
        sended: true,
      };
    },
    voidParadaRequest(state, paradaId) {
      state.anular.requestId += 1;
      state.anular.paradaId = paradaId;
      state.anular.data = null;
      state.anular.status = {
        canceling: true,
      };
    },
    voidParadaError(state, error) {
      state.anular.data = [];
      state.anular.status = {
        error,
      };
    },
    voidParadaSuccess(state, response) {
      state.anular.data = response;
      state.anular.status = {
        canceled: true,
      };
    },
    getEstadosParadaRequest(state) {
      state.estados.status = {
        loading: true,
      };
    },
    getEstadosParadaError(state, error) {
      state.estados.data = [];
      state.estados.status = {
        error,
      };
    },
    getEstadosParadaSuccess(state, response) {
      state.estados.data = response;
      state.estados.status = {
        loaded: true,
      };
    },
    getImagesRequest(state) {
      state.images.status = {
        loading: true,
      };
    },
    getImagesError(state, error) {
      state.images.data = [];
      state.images.status = {
        error,
      };
    },
    getImagesSuccess(state, response) {
      state.images.data = response;
      state.images.status = {
        loaded: true,
      };
    },
    getJustificantePDFByParadaRequest(state) {
      state.justificante.status = {
        loading: true,
      };
    },
    getJustificantePDFByParadaError(state, error) {
      state.justificante.data = [];
      state.justificante.status = {
        error,
      };
    },
    getJustificantePDFByParadaSuccess(state, response) {
      state.justificante.data = response;
      state.justificante.status = {
        loaded: true,
      };
    },
    createRecogidaRequest(state) {
      state.entityRecogida.requestId += 1;
      state.entityRecogida.status = {
        creating: true,
      };
    },
    createRecogidaError(state, error) {
      state.entityRecogida.data = [];
      state.entityRecogida.status = {
        error,
      };
    },
    createRecogidaSuccess(state, response) {
      state.entityRecogida.data = response;
      state.entityRecogida.status = {
        created: true,
      };
    },
    resetCreateRecogida(state) {
      state.entityRecogida.requestId += 1;
      state.entityRecogida.data = {};
      state.entityRecogida.status = {};
    },
  },
  actions: {
    ...excelParadasActions(() => paradaService),
    resetEventoParada({ commit }) { commit("resetEventoParada"); },
    getEventosDisponibles({ state, commit }, tipo) {
      if (state.eventosDisponibles.status.loading && state.eventosDisponibles.tipo === tipo) return;
      commit("getEventosDisponiblesRequest", tipo);
      const requestId = state.eventosDisponibles.requestId;
      paradaService.getEventosDisponibles(tipo)
        .then((response) => {
          if (requestId === state.eventosDisponibles.requestId) commit("getEventosDisponiblesSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.eventosDisponibles.requestId) commit("getEventosDisponiblesError", error);
        });
    },
    newEventoParada({ state, commit }, request) {
      if (state.newEventoParada.status.creating) return;
      commit("newEventoParadaRequest", request._id);
      const requestId = state.newEventoParada.requestId;
      paradaService.newEventoParada(request._id, request.body)
        .then((response) => {
          if (requestId === state.newEventoParada.requestId) commit("newEventoParadaSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.newEventoParada.requestId) commit("newEventoParadaError", error);
        });
    },
    ...enviosParadaActions,
    getParadas({ commit, state }, request) {
      commit("getParadasRequest");
      const requestId = state.list.requestId;
      return paradaService.getParadas(request.pagination, request.filters)
        .then((response) => { if (requestId === state.list.requestId) commit("getParadasSuccess", response); })
        .catch((error) => { if (requestId === state.list.requestId) commit("getParadasError", error); });
    },
    resetParadaInfo({ commit }) {
      commit("resetParadaInfo");
    },
    getParadaInfo({ commit, state }, masivoId) {
      commit("getParadaInfoRequest");
      const requestId = state.paradaId.requestId;
      paradaService
        .getParada(masivoId)
        .then((response) => {
          if (requestId === state.paradaId.requestId)
            commit("getParadaInfoSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.paradaId.requestId)
            commit("getParadaInfoError", error);
        });
    },
    getEtiquetaPDFByParada({ commit }, idParada) {
      commit("getEtiquetaPDFByParadaRequest");
      paradaService
        .getEtiquetaPDFByParada(idParada)
        .then((response) => {
          commit("getEtiquetaPDFByParadaSuccess", response);
        })
        .catch((error) => {
          commit("getEtiquetaPDFByParadaError", error);
        });
    },
    sendEmailEtiquetasByParada({ commit }, idParada) {
      commit("sendEmailEtiquetasByParadaRequest");
      paradaService
        .sendEmailEtiquetasByParada(idParada)
        .then((response) => {
          commit("sendEmailEtiquetasByParadaSuccess", response);
        })
        .catch((error) => {
          commit("sendEmailEtiquetasByParadaError", error);
        });
    },
    voidParada({ state, commit }, idParada) {
      if (state.anular.status.canceling) return;
      commit("voidParadaRequest", idParada);
      const requestId = state.anular.requestId;
      paradaService
        .anularParada(idParada)
        .then((response) => {
          if (requestId === state.anular.requestId) commit("voidParadaSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.anular.requestId) commit("voidParadaError", error);
        });
    },
    getEstadosParada({ commit }, idParada) {
      commit("getEstadosParadaRequest");
      paradaService
        .estadosParada(idParada)
        .then((response) => {
          commit("getEstadosParadaSuccess", response);
        })
        .catch((error) => {
          commit("getEstadosParadaError", error);
        });
    },
    getImages({ commit }, id) {
      commit("getImagesRequest");
      paradaService
        .getImages(id)
        .then((response) => {
          commit("getImagesSuccess", response);
        })
        .catch((error) => {
          commit("getImagesError", error);
        });
    },
    getJustificantePDFByParada({ commit }, idParada) {
      commit("getJustificantePDFByParadaRequest");
      paradaService
        .getJustificantePDFByParada(idParada)
        .then((response) => {
          commit("getJustificantePDFByParadaSuccess", response);
        })
        .catch((error) => {
          commit("getJustificantePDFByParadaError", error);
        });
    },
    resetCreateRecogida({ commit }) {
      commit("resetCreateRecogida");
    },
    createRecogida({ state, commit }, idParada) {
      if (state.entityRecogida.status.creating) return;
      commit("createRecogidaRequest");
      const requestId = state.entityRecogida.requestId;
      paradaService
        .createRecogida(idParada)
        .then((response) => {
          if (requestId === state.entityRecogida.requestId)
            commit("createRecogidaSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.entityRecogida.requestId)
            commit("createRecogidaError", error);
        });
    },
  },
};
